import { render } from "./LotteryExplain.vue?vue&type=template&id=39313d92&scoped=true"
import script from "./LotteryExplain.vue?vue&type=script&lang=js"
export * from "./LotteryExplain.vue?vue&type=script&lang=js"

import "./LotteryExplain.vue?vue&type=style&index=0&id=39313d92&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39313d92"]])

export default __exports__